module.exports = __webpack_public_path__ + "img/avatar-voorstel-vrouw.4d834a26.jpeg";